export default __webpack_public_path__ + "static/media/news_main_image.d90057af.jpg";